var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-select",
    {
      attrs: { "is-value-selected": "", placeholder: _vm.placeholder },
      on: { apply: _vm.applyFilter, close: _vm.localClear },
      scopedSlots: _vm._u([
        {
          key: "head",
          fn: function() {
            return [
              _vm.showTag
                ? _c("custom-select-tag-head", {
                    attrs: { title: _vm.tagTitle },
                    on: { clear: _vm.clear }
                  })
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("custom-select-price-dropdown-content", {
        attrs: {
          slot: "dropdown-content",
          from: _vm.from,
          to: _vm.to,
          min: _vm.minMax.min.toString(),
          max: _vm.minMax.max.toString()
        },
        on: { "update-price": _vm.updatePrice },
        slot: "dropdown-content"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }